/* eslint-disable no-nested-ternary */
import React from 'react';
// assets
import { GiFemale, GiMale } from 'react-icons/gi';
import { LuSend } from "react-icons/lu";
import DefaultProfile from '../../../../assets/images/default_profile.jpeg';

function AlcoholPatientDataSidebar({
	patientData,
	birthDisplay,
	phoneDisplay,
	patientProfileImage,
	showModifyPatientModal,
	showSendMessageModal
}) {
	return (
		<div className="patientManageDetail__patient">
			<button className="patient_edit submitButton__rounded" onClick={showModifyPatientModal}>수정</button>
			<div className="patient_profile">
				<img src={patientProfileImage || DefaultProfile} alt="" className="profileImage" />
				<div className="profileName">
					{patientData.sex ? (
						patientData.sex === 'M' ? (
							<GiMale style={{ transform: 'rotate(90deg)', color: '#53a5fc' }} />
						) : (
							<GiFemale style={{ transform: 'rotate(-45deg)', color: '#fc7cb4' }} />
						)
					) : null}
					<span>
						{patientData.name ? patientData.name : '-'}
						{patientData.age ? `(${patientData.age})` : null}
						<button
							type='button'
							className='message_send_button'
							onClick={showSendMessageModal}
							aria-label='Message Send Button'
						>
							<LuSend />
						</button>
					</span>
				</div>
			</div>
			<div className="patient_detail colored">				
				<div className="patient_detailItem">
					<span>생년월일</span>
					<span>
						{birthDisplay || '-'}
					</span>
				</div>
				<div className="patient_detailItem">
					<span>휴대폰 번호</span>
					<span>
						{phoneDisplay || '-'}
					</span>
				</div>
			</div>
			<div className="patient_detail">
				<div className="patient_detail__title">음주자신감변화도</div>
				<div className="patient_detailItem">
					<span>음주습관 변화 자신감 점수</span>
					<span>{patientData.habitScore}</span>
				</div>
			</div>
			<div className="patient_detail">
				<div className="patient_detail__title">모듈 타입</div>
				<div className="patient_detailBox">
					<div>
						<div>문제성 음주</div>
						<div>변화 준비</div>
					</div>
					<div>
						<div className={`${patientData.audit==="High" ? "bold" : ""}`}>High</div>
						<div className={`${patientData.rtcq==="Ready" ? "bold" : ""}`}>Ready</div>
					</div>
					<div>
						<div className={`${patientData.audit==="Low" ? "bold" : ""}`}>Low</div>
						<div className={`${patientData.rtcq==="No" ? "bold" : ""}`}>No</div>
					</div>
				</div>
			</div>
			<div className="patient_detail">
				<div className="patient_detail__title">어플 사용 정보</div>
				<div className="patient_detailItem">
					<span>진행중 교육</span>
					<span>{patientData.weekNum ? `${patientData.weekNum}` : '0'} 회기 진행중</span>
				</div>
				<div className="patient_detailItem">
					<span>금주일지 작성</span>
					<span>{patientData.journaling ? `${patientData.journaling}` : '0'} 회</span>
				</div>
				<div className="patient_detailItem">
					<span>연속금주일</span>
					<span>{patientData.doNotDrink ? `${patientData.doNotDrink}` : '0'} 일</span>
				</div>
				<div className="patient_detailItem">
					<span>SOS 실행</span>
					<span>{patientData.sosCnt ? `${patientData.sosCnt}` : '0'} 회</span>
				</div>
			</div>
		</div>
	);
}

export default AlcoholPatientDataSidebar;
